import * as React from "react";
import { Spin } from "antd";
import { SessionStore, LocaleStore, RouterStore, PriceStore } from "../stores";
import { inject, observer } from "mobx-react";

export interface Props {
  session: SessionStore;
  router: RouterStore;
  locale: LocaleStore;
  price: PriceStore;
}

@inject("session", "locale", "router", "price")
export default class Spinner extends React.Component<any> {
  render() {
    const { locale } = this.props;
    return (
      <Spin tip={locale.get("global.loading")} size="large">
        <div style={{ minHeight: "100vh", minWidth: "100%" }}></div>
      </Spin>
    );
  }
}
